import { DEFAULT_TEMPLATE_FORM_LANGUAGE } from '@common/i18n/constants';
import { getVerifyEmailTranslations } from '@common/i18n/verifyEmail';
import type { TemplateFormLanguage } from '@common/types/templateForms';
import { Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import LoadingButton from '@/components/Buttons/LoadingButton';

interface Props {
    open: boolean;
    loading: boolean;
    verifyEmail: string;
    isModalVerified: boolean;
    onClose: () => void;
    onEmailChange: (email: string) => void;
    onVerify: () => void;
    isIntakeForm: boolean;
    language?: TemplateFormLanguage;
}

export default function VerifyEmailDialog({
    open,
    loading,
    verifyEmail,
    isModalVerified,
    onClose,
    onEmailChange,
    onVerify,
    isIntakeForm,
    language = DEFAULT_TEMPLATE_FORM_LANGUAGE,
}: Props) {
    const t = getVerifyEmailTranslations(language);
    return (
        <Dialog
            open={open}
            onClose={(_event, reason) => {
                if (reason === 'backdropClick') return;
                onClose();
            }}
        >
            <DialogTitle>{t.title(isIntakeForm ? 'intake' : 'draft')}</DialogTitle>
            <DialogContent>
                <TextField
                    margin="dense"
                    label={t.emailLabel}
                    type="email"
                    fullWidth
                    value={verifyEmail}
                    onChange={(e) => onEmailChange(e.target.value)}
                    required
                    error={isModalVerified && !verifyEmail}
                    helperText={isModalVerified && !verifyEmail ? t.fieldRequired : ''}
                    InputLabelProps={{
                        shrink: true,
                    }}
                />
            </DialogContent>
            <DialogActions>
                <LoadingButton
                    disabled={loading}
                    loading={loading}
                    onClick={onVerify}
                    variant="contained"
                >
                    {loading ? t.verifying : t.verify}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}
